const Backbone = require('lib/backbone')
const Marionette = require('lib/marionette')
const _ = require('lib/underscore')
const Form = require('../model/form')
const ElementView = require('./element_view')
const InputViews = require('./input_view_types')
const log = require('log').create('freeform', 'form_view')  


const FormView = Marionette.View.extend({

    displayName: 'FormView',

    tagName: 'form',

    elementView: ElementView,

    formViewEvents: {
        'render': 'renderForm',
    },

    triggers: {
        'submit': 'validate:and:submit',
        'reset': {
            event: 'form:reset',
            preventDefault: false,
            stopPropagation: false,
        },
    },

     
    constructor: function constructor(options = {}) {
        // set up form model
        options.model = this.setupFormModel(options.model)

        // validate elementView
        if (options.elementView) this.elementView = options.elementView
        this.validateElementView()

        Marionette.View.call(this, options)

        // bind view events
        Marionette.bindEvents(this, this, this.formViewEvents)
        this.listenTo(this.model, 'change:disabled', this.setDisabledState)
    },

    setupFormModel(model) {
        if (model instanceof Form) return model

        if (model instanceof Backbone.Model) {
            return new Form(model.attributes)
        }

        return model
    },

    validateElementView() {
        if (this.elementView === ElementView) return
        if (this.elementView.prototype instanceof ElementView) return
        throw new Error('FormView.elementView must be an ElementView.')
    },

    renderForm() {
        this.triggerMethod('before:render:form')
        this.setDisabledState()
        this.addElementViews()
        this.bindUIElements()
        this.triggerMethod('render:form')
    },
    onFormReset() {
        // form reset doesn't trigger any change event on the inputs that are changed by resetting
        // so we have to shim that event in order to reset any validation errors
        // have to defer this so the reset event can complete and values are restored
        _.defer(() => {
            this.$('input, select, textarea').trigger('change')
        })
    },

    setDisabledState() {
        const attrs = this.model.pick('disabled')
        this.model.get('elements').each(element => {
            element.set(attrs)
            if (element.get('type') === 'buttonset') {
                element.get('buttons').each(button => button.set(attrs))
            }
        })
    },

    addElementViews() {
        const elements = this.model.get('elements')
        elements.each(this.addElementView, this)
    },

    addElementView(element) {
        const View = this.getElementView(element)
        const view = new View({
            el: this.$(element.get('el')),
            model: element,
            form: this.model,
        })
        view.render()
        this.listenTo(this, 'before:destroy', () => {
            view.destroy()
        })
    },

    getElementView(element) {
        if (element.get('raw')) {
            const type = element.get('type')
            const View = InputViews[type]
            if (View) return View
            throw new Error(`No raw InputView defined for type ${type}`)
        } else {
            return this.elementView
        }
    },

    // API method for triggering a reset
    reset() {
        this.$el.trigger('reset')
    },

    // API method for triggering a submit
    submit() {
        this.$el.trigger('submit')
    },

    // API methods for disabling/enabling the entire form
    disableForm() {
        this.model.set('disabled', true)
    },
    enableForm() {
        this.model.set('disabled', false)
    },

    onValidateAndSubmit() {
        log('onValidateAndSubmit')
        // don't submit if already submitting
        if (this.model.get('submitting')) return

        this.triggerMethod('before:form:submit')

        // trigger change manually before validation to ensure model values are
        // up to date. don't defer this.
        this.$('input, select, textarea').trigger('change')

        if (this.model.isValid()) {
            if (! this.onFormSubmit) {
                log('Form is valid. Implement your own onFormSubmit handler to do something with the form data.')
            }
            this.triggerMethod('form:submit')
        } else {
            log('Form is not valid.', this.model.validationError)
            this.triggerMethod('form:submit:error')
        }
    },

})

module.exports = FormView
